module.exports = __webpack_public_path__ + "img/9788958283829.d2bc5ac7.jpg";